import "./BillingCollectionToolbar.css";

const BillingCollectionToolbar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  summary,
  children,
}) => (
  <section className="billing-collection-toolbar">
    <div className="billing-collection-toolbar__search">
      <label
        className="billing-collection-toolbar__search-label"
        htmlFor="billing-collection-search"
      >
        Search
      </label>
      <input
        id="billing-collection-search"
        className="billing-collection-toolbar__search-input"
        type="search"
        value={searchValue}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={searchPlaceholder}
      />
    </div>

    {children ? (
      <div className="billing-collection-toolbar__filters">{children}</div>
    ) : null}

    {summary ? (
      <div className="billing-collection-toolbar__summary">{summary}</div>
    ) : null}
  </section>
);

export default BillingCollectionToolbar;
